module.exports = __webpack_public_path__ + "static/media/2576ec7a.jpg";